import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Modal } from 'antd';
import { useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { CooksHeader } from '../layout/PageHeader';
import { getCooksProfileState } from '../../store/cooksprofile/selectors';
import { getUserState } from '../../store/user/selector';

// import UserIcon from '../../assets/images/png/nav/user.png';
import UserIconActive from '../../assets/images/png/nav/swap/personal_icon.png';
import UtensilFork from '../../assets/images/png/nav/swap/seek.png';
// import UtensilForkActive from '../../assets/images/png/utensil-forkActive.png';

import { getMeals } from '../../store/cooksprofile/actions';
import { ProfileReportHandler } from './ProfileReport';

import { Cook } from './Cook';
import { Guest } from './Guest';

interface ReportProps {
  onPressReport?: (e?: React.MouseEvent) => void;
  onPressCancel?: (e?: React.MouseEvent) => void;
  type: string;
  t: Function;
}

export interface ReportState {
  reportMessage: string;
}

export interface ModalSuccessContentProps {
  icon: string;
  message: string;
  onClick?: (e?: React.MouseEvent) => void;
}

export const ProfileReportButton: React.FC<ReportProps> = ({
  onPressReport,
  onPressCancel,
  type,
  t,
}) => {
  return (
    <div className="button-container">
      <Button
        block
        type="default"
        onClick={onPressReport}
        className="continue-button continue-button-report-primary"
      >
        <span className="continue-button-report-text">
          {type === 'i seek' ? t('Report i seek') : t('Report i offer')}
        </span>
      </Button>
      <Button
        block
        type="default"
        onClick={onPressCancel}
        className="continue-button continue-button-report-primary"
      >
        <span className="cancel-button-report-text">{t('Cancel')}</span>
      </Button>
    </div>
  );
};

export const closeModal = () => {
  Modal.destroyAll();
};

export const UserProfile: React.FC = () => {
  const [active, setActive] = useState(true);
  const [userDetails, setUserDetails] = useState(Object);
  const { meals } = useSelector(getCooksProfileState);
  const { user } = useSelector(getUserState);
  const isGuest = user.accountType === 'i seek';
  const location = useLocation();
  const { state } = location;
  const userdetails = state;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const setUser = () => {
    setUserDetails(userdetails);
  };
  useEffect(setUser, [userdetails]);

  const reports = {
    reportedby: user.userid,
    user: userDetails.id,
    type: userDetails.type,
  };
  const handleOnPressReport = () => {
    closeModal();
    ProfileReportHandler({ reports });
  };
  const reportModalConfig = {
    icon: null,
    false: true,
    centered: true,
    className:
      'report-modal-content-container report-modal-content-description',
    okButtonProps: { style: { display: 'none' } },
    content: (
      <ProfileReportButton
        onPressReport={handleOnPressReport}
        onPressCancel={closeModal}
        type={userDetails.type}
        t={t}
      />
    ),
  };

  const changeActive = (key: string) => {
    if (key === '1') {
      setActive(!active);
    } else {
      setActive(!active);
    }
  };

  const handleButtonPress = () => {
    Modal.info(reportModalConfig);
  };
  const validate = () => {
    dispatch(getMeals(userDetails.id));
  };
  useEffect(validate, [userDetails]);
  const USER = UserIconActive;
  const COOK = UtensilFork;
  const userinfo = {
    cookDetails: userDetails,
  };
  return (
    <div className="profile">
      <div>
        <CooksHeader
          headerTitle={userDetails.type === 'i seek' ? 'i seek' : 'i offer'}
          onClickModal={handleButtonPress}
        />
      </div>
      <Row justify="center" className="cooks-container">
        <Col xs={24} sm={24} md={24} lg={24} className="user-profile-screen">
          {userDetails.type === 'i seek' ? (
            <Guest userdetails={userdetails} />
          ) : (
            <Cook
              meals={meals}
              cook={COOK}
              user={USER}
              userdetails={userdetails}
              userinfo={userinfo}
              isGuest={isGuest}
              changeActive={changeActive}
              active={active}
            />
          )}
        </Col>
      </Row>
    </div>
  );
};
